module.exports = __webpack_public_path__ + "img/tiekuangshigy.a0702aa3.jpg";